import { instance } from "../instance";
import { IAxiosError } from "../interfaces";
import { getError } from "../utils";
import { PATH } from "../../shared/constants";

export interface CreateSupportRequestInput {
  email: string;
  message: string;
  source?: string;
  pageHost?: string;
  gameContext?: string;
  seatContext?: string;
  /** HTTPS URLs returned from presign + upload (max 5 on server). */
  attachmentUrls?: string[];
}

export interface PresignSupportAttachmentResponse {
  success: boolean;
  uploadKey: string;
  uploadURL: string;
  imageShortUrl: string;
}

export const presignSupportAttachmentUpload = async (
  fileMimeType: string,
): Promise<PresignSupportAttachmentResponse> => {
  try {
    const response = await instance.post<PresignSupportAttachmentResponse>(
      `${PATH.API}/${PATH.SUPPORT}/attachment-presign`,
      { fileMimeType },
    );
    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};

export const createSupportRequest = async (
  request: CreateSupportRequestInput,
): Promise<{ _id: string }> => {
  try {
    const response = await instance.post<{ _id: string }>(
      `${PATH.API}/${PATH.SUPPORT}`,
      request,
    );
    return response.data;
  } catch (err) {
    const { response } = err as IAxiosError;
    throw new Error(getError(response));
  }
};
